import(/* webpackMode: "eager" */ "/codebuild/output/src2878464499/src/signage-website/app/error.tsx");
